module.exports = __webpack_public_path__ + "media/images/35photo-c9de4e773ab0aad201298bad44da2ed8.png";